import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Button, Modal, Form, Row, Col, Tabs, Tab, InputGroup, Badge } from "react-bootstrap";
import {
  Paper,
  TextField,
  Grid,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  makeStyles,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Checkbox,
} from "@material-ui/core";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { Formik } from "formik";
import SearchIcon from "@material-ui/icons/Search";
import * as Admin from "../../../store/ducks/admin.duck";
import * as Reference from "../../../store/ducks/reference.duck";
import * as Registration from "../../../store/ducks/registration.duck";
import PlacesAutoComplete from "../../../components/AddressAutoComplete";
import BookingsList from "../../../components/BookingsList";
import BookingBillingList from "../../../components/BookingBillingList";
import { BookingWeek } from "../../../components/Appointments";
import ReferralMaintenance from "../../../components/ReferralMaintenance";
import Notes from "../../../components/Notes";
import Files from "../../../components/Files";
import ToDos from "../../../components/ToDos";
import AuditLog from "../../../components/AuditLog";
import ClientScores from "../../../components/ClientScores";
import { ToastContainer, Flip } from "react-toastify";
import { format, differenceInYears } from "date-fns";
import * as Yup from "yup";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../_metronic/_assets/css/app.css";
import "../../../../_metronic/_assets/css/app2.css";

const useStyles = makeStyles((theme) => ({
  noBorder: {
    border: "none",
  },
  formControl: {
    margin: 0, //theme.spacing(1),
    minWidth: 120,
  },
  formControlWide: {
    margin: 0, //theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  label: {
    backgroundColor: "#fff",
    paddingLeft: 3,
    paddingRight: 3,
  },
}));

// Define Program Question responses
const programPopulationOptions = [
  {
    id: "1",
    index: "1",
    name: "Aboriginal and/or Torres Strait Islander",
  },
  {
    id: "2",
    index: "2",
    name: "Culturally and linguistically diverse",
  },
  {
    id: "3",
    index: "3",
    name: "Migrant and Refugee",
  },
  {
    id: "4",
    index: "4",
    name: "Under 20",
  },
  {
    id: "5",
    index: "5",
    name: "Rural and Remote",
  },
];

const fieldLabels = {
  firstname: "Personal Tab - First Name",
  preferredname: "Personal Tab - Preferred Name",
  surname: "Personal Tab - Surname",
  dob: "Personal Tab - Date of Birth",
  email: "Personal Tab - Email",
  mobilephone: "Personal Tab - Mobile Phone",
  fulladdress: "Personal Tab - Address",
  pronouns: "Pronouns",

  emergencycontactname1: "Personal Tab - Emergency Contact Name",
  emergencycontactrelation1: "Personal Tab - Emergency Contact Relationship",
  emergencycontactphone1: "Personal Tab - Emergency Contact Phone",

  emergencycontactname2: "Personal Tab - Second Emergency Contact Name",
  emergencycontactrelation2: "Personal Tab - Second Emergency Contact Relationship",
  emergencycontactphone2: "Personal Tab - Second Emergency Contact Phone",
  hopeToGetFromTreatment: "Personal Tab - Hope to Get From Treatment",
  medicarereferenceno: "Personal Tab - Medicare Reference Number",
  medicareexpirydate: "Personal Tab - Medicare Expiry Date",
  medicareno: "Personal Tab - Medicare Card Number",

  ndisnumber: "Personal Tab - NDIS Number",
};

export default function ClientsPsychologist() {
  const classes = useStyles();
  const [searchTerm, setSearchTerm] = useState("");
  const [haveBookings, sethaveBookings] = useState(false);

  const dispatch = useDispatch();
  const clients = useSelector((state) => state.admin.Clients);
  const client = useSelector((state) => state.admin.Client);
  const filters = useSelector((state) => state.admin.Filters);
  const [formClient, setFormClient] = useState(null);

  const validateMedicareNumber = require("validate-medicare-number");

  const searchClients = (client) => {
    if (
      true &&
      (client.fullname.toLowerCase().search(searchTerm.toLowerCase()) > -1 || searchTerm.length === 0) &&
      // && (client.clientAreasOfInterest.some(issue => issue === searchAOI) || searchAOI === '')
      (filters.clientsStatus === "All" ||
        (filters.clientsStatus === "Active" && client.status === "Active" && client.closureProviderStatus !== "Complete") ||
        (filters.clientsStatus === "Closed" && client.status === "Closed" && client.closureProviderStatus !== "Complete") ||
        (filters.clientStatus === "CSComplete" && client.closureProviderStatus === "Complete") ||
        (filters.clientsStatus === "Archived" && client.status === "Archived"))
    ) {
      return client;
    }
  };

  const filteredClients = clients.filter((client) => searchClients(client));

  // Email Duplicate Check
  const [emailIsDuplicate, setEmailIsDuplicate] = useState(false);
  const emailDuplicate = useSelector((state) => state.registration.EmailDuplicate);

  const checkEmailDuplicate = useCallback(
    (newEmailDuplicate) => {
      setEmailIsDuplicate(newEmailDuplicate === true);
      dispatch(Registration.actions.emailDuplicateClear());
    },
    [dispatch],
  );

  useEffect(() => {
    //
    // Some Commentary about this
    // Essentially when someone creates a submits a form, a processing window appears and disappears once the form is processed
    // To do this a Redux variable - <formtype>Form  is set with a number - null is not set, 1 is processing and 2 is an error state
    //
    if (emailDuplicate) {
      checkEmailDuplicate(emailDuplicate);
    }
  }, [emailDuplicate, checkEmailDuplicate]);

  // May need to consider this - do providers need to see inactive clients?
  useEffect(() => {
    dispatch(Admin.actions.fetchClients({ status: filters.clientsStatus }));
  }, [dispatch, filters.clientsStatus]);
  useEffect(() => {
    dispatch(Admin.actions.fetchMedicalPractitioners());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchMedicalPractices({ type: "GeneralPractitioner" }));
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchTimeZone());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchConstants());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchFundingTypes());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchSundayThisWeek());
  }, [dispatch]);
  useEffect(() => {
    dispatch(
      Reference.actions.fetchAreasOfInterest({
        providerType: "ALL",
        centralisedservice: false,
      }),
    );
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchRegistered());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchPrograms());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchCsCentres());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchCsAgents());
  }, [dispatch]);

  const registered = useSelector((state) => state.admin.RegisteredPsychologists[0]);
  const providerType = useSelector((state) => state.admin.RegisteredPsychologists[0] && state.admin.RegisteredPsychologists[0].providertype);
  const userTZ = useSelector((state) => state.auth.userTZ);
  const medicalPractitioners = useSelector((state) => state.admin.MedicalPractitioners);
  const medicalPractices = useSelector((state) => state.admin.MedicalPractices.GeneralPractitioner);
  const timeZone = useSelector((state) => state.reference.TimeZone);
  const areasOfInterestReference = useSelector((state) => state.reference.AreasOfInterest);
  const areasOfInterest = areasOfInterestReference.filter((area) => area.providertype === providerType);
  const programs = useSelector((state) => state.admin.Programs);
  const csCentres = useSelector((state) => state.admin.CsCentres);
  const csAgents = useSelector((state) => state.admin.CsAgents);
  const bookings = useSelector((state) => state.admin.Bookings);

  const getBookings = () => {
    if (!haveBookings && registered) {
      dispatch(
        Admin.actions.fetchBookings({
          key: "psychologist",
          id: registered.id,
          userTZ: userTZ,
        }),
      );
      sethaveBookings(true);
    }
  };

  useEffect(() => {
    if (filters.clientsListLoadClientID) {
      loadClient(filters.clientsListLoadClientID);

      dispatch(
        Admin.actions.setFilters({
          filterName: "clientsListLoadClientID",
          filterValue: undefined,
        }),
      );
    }
  }, [filters.clientsListLoadClientID, providerType, dispatch]);

  useEffect(() => {
    getBookings();
  }, [registered]);

  var [show, setShow] = useState(false);
  var [showAppointment, setShowAppointment] = useState(false);
  var [showNotes, setShowNotes] = useState(false);
  var [showFiles, setShowFiles] = useState(false);
  var [showCSComplete, setShowCSComplete] = useState(false);
  const [showToDo, setShowToDo] = useState(false);
  const [toDoClientID, setToDoClientID] = useState();
  const [toDoTitle, setToDoTitle] = useState("");

  const initMedicalPractitioner = () => {
    return {
      id: 0,
      providernumber: "",
      salutation: "Dr",
      firstName: "",
      surname: "",
      fullname: "",
      mobilephone: "",
      phone: "",
      type: "Client GP",
    };
  };

  const initMedicalPractice = useCallback(() => {
    return {
      id: 0,
      abn: "",
      practicename: "",
      phone: "",
      address1: "",
      email: "",
      website: "",
      logoURL: "",
      practiceType: "GeneralPractitioner",
    };
  }, []);

  const initProgram = useCallback(() => {
    return {
      id: 0,
      name: "",
      identifier: "",
      description: "",
      status: "Active",
      aoi: 0,
      availabilitytype: "",
      bulkbilling: "N",
    };
  }, []);

  const initCSCentre = () => {
    return {
      id: 0,
      cSCentreID: "",
      centerName: "",
      email: "",
      phone: "",
      contact: "",
      contactEmail: "",
      phone: "",
    };
  };

  const loadMedicalPractitice = useCallback(
    (thisMedicalPractice) => {
      setcurrentMedicalPractice(thisMedicalPractice ? thisMedicalPractice : initMedicalPractice());
    },
    [initMedicalPractice],
  );

  const loadMedicalPractitioner = useCallback(
    (thisMedicalPractitioner) => {
      setcurrentMedicalPractitioner(thisMedicalPractitioner ? thisMedicalPractitioner : initMedicalPractitioner());
      setcurrentMedicalPractitionerID(thisMedicalPractitioner ? thisMedicalPractitioner.id : 0);
      var tempMedicalPractice = thisMedicalPractitioner ? medicalPractices.find((v) => v.id === thisMedicalPractitioner.medicalPracticeID) : null;
      loadMedicalPractitice(tempMedicalPractice);
    },
    [loadMedicalPractitice, medicalPractices],
  );

  function handleAppointmentTypeChange(value) {
    setcurrentAppointmentType(value);
  }

  var [currentMedicalPractitioner, setcurrentMedicalPractitioner] = useState(initMedicalPractitioner());
  var [currentMedicalPractice, setcurrentMedicalPractice] = useState(initMedicalPractice());

  const getMedicalPractitionerOption = (option, value) => {
    if (option.id === value.id) {
      return option;
    } else {
      return initMedicalPractitioner();
    }
  };

  const getMedicalPracticeOption = (option, value) => {
    if (option.id === value.id) {
      return option;
    } else {
      return initMedicalPractice();
    }
  };

  function handleTimeZoneAutocompleteChange(propertyName, event, newValue) {
    if (newValue) {
      setcurrentTimeZone(newValue.systemName);
    }
  }

  const getProgramOption = (option, value) => {
    if (option.id === value.id) {
      return option;
    } else {
      return initProgram();
    }
  };

  function putArchive() {
    // Archive client - i.e. alter status to Archived from Active
    // console.log(currentClientID);
    dispatch(
      Admin.actions.putClientArchive({
        id: currentClientID,
        changetype: currentAction,
      }),
    );
    setShowConfirmation(false);
  }

  function putCSComplete() {
    // Complete CS Client and send notifications etc.
    dispatch(
      Admin.actions.putProviderCSComplete({
        id: currentID,
      }),
    );
    setShowCSComplete(false);
  }

  function getIndex(value, arr, prop) {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i][prop] === value) {
        return i;
      }
    }
    return -1; // where the value doesn't exist
  }

  const handleToggle = (value) => () => {
    const currentIndex = getIndex(value.id, currentProgramPopulation, "id"); //checked.find(r => r.id === value.id);
    const newChecked = [...currentProgramPopulation];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setcurrentProgramPopulation(newChecked);
  };

  function putClient(values) {
    console.log(values);
    const payload = {
      profileClientID: values.id,
      profileFirstName: values.firstname,
      profilePreferredName: values.preferredname,
      profileSurname: values.surname,
      profileDOB: values.dob,
      profileEmail: values.email,
      profileGender: values.gender,
      profileOccupation: values.occupation,
      profileMobile: values.mobilephone,
      profilefulladdress: values.fulladdress,
      profileStatus: values.status,
      profilepreviousstatus: values.previousstatus,
      profileNote: values.note,
      profilehopeToGetFromTreatment: values.hopeToGetFromTreatment,

      profileMedicalPractitionerID: values.medicalPractitionerID,
      profilePaymentType: values.paymentType,
      profileTimeZone: values.timeZone,
      profileLatitude: values.latitude,
      profileLongitude: values.longitude,
      profilePostCode: values.postCode,

      emergencycontactname1: values.emergencycontactname1,
      emergencycontactphone1: values.emergencycontactphone1,
      emergencycontactrelation1: values.emergencycontactrelation1,

      emergencycontactname2: values.emergencycontactname2,
      emergencycontactphone2: values.emergencycontactphone2,
      emergencycontactrelation2: values.emergencycontactrelation2,

      profilemedicareno: values.medicareno,
      profilemedicarereferenceno: values.medicarereferenceno,
      profilemedicareexpirydate: values.medicareexpirydate,

      profileAreasOfInterest: values.clientAreasOfInterest.map((aoi) => aoi.issue).join(","),

      medicalPractice: values.medicalPractice,
      medicalPractitioner: values.medicalPractitioner,

      status: values.status,
      appointmenttype: values.appointmenttype,

      profilegpname: values.gpName,
      profilegpclinicname: values.gpClinicName,

      profilendisnumber: values.ndisnumber,
      profilendisdatefrom: values.ndisdatefrom,
      profilendisdateto: values.ndisdateto,
      profilendisplanmanagementprovider: values.ndisplanmanagementprovider,
      profilendisdiagnosishistory: values.ndisdiagnosishistory,
      profilendisemailforinvoices: values.ndisemailforinvoices,
      profilendisbookingfee: values.ndisbookingfee,
      profileRHCNDISItemCode: values.rhcndisitemcode,
      profileNDISBillingNote: values.ndisbillingnote,

      profilepassword: null,
      profilepasswordconfirmation: null,

      profileConsentToShareWithGP: values.consentToShareWithGP,
      profilePronouns: values.pronouns,
      profileIndigenous: values.indigenous,

      profileNDISSupportCoordinator: values.ndissupportcoordinator,
      profileNDISSupportCoordinatorPhone: values.ndissupportcoordinatorphone,

      profileprogrampopulation: values.programpopulation.map((pp) => pp.name).join(","),

      profileNthQLDPHNBookings: values.nthQLDPHNEstimated,
    };

    dispatch(Admin.actions.putClientDetail(payload));
    setShow(false);
  }

  const initClient = {
    id: 0,
    firstname: "",
    preferredname: "",
    surname: "",
    dob: "",
    email: "",
    gender: "",
    occupation: "",
    mobilephone: "",
    fulladdress: "",
    status: "",
    previousstatus: "",
    note: "",
    hopeToGetFromTreatment: "",
    medicalPractitionerID: 0,
    paymentType: "",
    timeZone: "",
    latitude: "",
    longitude: "",
    postCode: "",
    emergencycontactname1: "",
    emergencycontactphone1: "",
    emergencycontactrelation1: "",
    emergencycontactname2: "",
    emergencycontactphone2: "",
    emergencycontactrelation2: "",
    medicareno: "",
    medicarereferenceno: "",
    medicareexpirydate: "",
    appointmenttype: "",
    gpName: "",
    gpClinicName: "",
    ndisnumber: "",
    ndisdatefrom: "",
    ndisdateto: "",
    ndisplanmanagementprovider: "",
    ndisdiagnosishistory: "",
    ndisemailforinvoices: "",
    ndisbookingfee: "",
    rhcndisitemcode: "",
    ndisbillingnote: "",
    consentToShareWithGP: "",
    pronouns: "",
    indigenous: "",
    ndissupportcoordinator: "",
    ndissupportcoordinatorphone: "",
    nthQLDPHNEstimated: "",
  };

  function loadFiles(thisClient) {
    setcurrentClientID(thisClient.id);
    setcurrentPaymentType(thisClient.paymentType);
    setcurrentFirstName(thisClient.firstname);
    setcurrentPreferredName(thisClient.preferredname);
    setcurrentSurname(thisClient.surname);
    setcurrentSpecialistType(thisClient.specialisttype);
    setShowFiles(true);
  }

  function loadNotes(thisClient, noteAction) {
    setNoteAction(noteAction);
    setcurrentClientID(thisClient.id);
    setcurrentID(thisClient.id);
    setcurrentFirstName(thisClient.firstname);
    setcurrentPreferredName(thisClient.preferredname);
    setcurrentSurname(thisClient.surname);
    setcurrentReferralGPPracticeFax(thisClient.referralGPPracticeFax);
    setcurrentEmail(thisClient.email);
    setcurrentSpecialistType(thisClient.specialisttype);
    setcurrentMobile(thisClient.mobilephone);
    setcurrentNoteViewType("CommunicationOnly");
    setShowNotes(true);
  }

  function loadNoteOnly(thisClient, noteAction) {
    setNoteAction(noteAction);
    setcurrentClientID(thisClient.id);
    setcurrentID(thisClient.id);
    setcurrentFirstName(thisClient.firstname);
    setcurrentPreferredName(thisClient.preferredname);
    setcurrentSurname(thisClient.surname);
    setcurrentReferralGPPracticeFax(thisClient.referralGPPracticeFax);
    setcurrentEmail(thisClient.email);
    setcurrentNoteViewType("NoteOnly");
    setcurrentSpecialistType(thisClient.specialisttype);
    setcurrentMobile(thisClient.mobilephone);
    setShowNotes(true);
  }

  const loadArchive = (thisClient, action) => {
    // console.log(providerType);
    setcurrentClientID(thisClient.id);
    setcurrentID(thisClient.id);
    setcurrentFirstName(thisClient.firstname);
    setcurrentPreferredName(thisClient.preferredname);
    setcurrentSurname(thisClient.surname);
    setcurrentAction(action);

    setShowConfirmation(true);
  };

  const loadCSComplete = (thisClient) => {
    setcurrentID(thisClient.id);
    setcurrentFirstName(thisClient.firstname);
    setcurrentSurname(thisClient.surname);
    setShowCSComplete(true);
  };

  const loadClient = (id) => {
    if (isNaN(id)) {
      // It's a GUID
      dispatch(Admin.actions.fetchClient({ clientID: 0, clientGUID: id, type: providerType }));
    } else {
      // It's a number, so we can fetch the client directly by ID
      dispatch(Admin.actions.fetchClient({ clientID: id, type: providerType }));
    }
    setcurrentProgram(false);
  };

  const loadProfile = useCallback(
    (thisClient, selectedTab) => {
      // Things needed to calculate/display related data
      const owner = csAgents.find((agent) => String(agent.id) === String(thisClient.owner));
      const csCentre = csCentres.find((v) => String(v.id) === String(thisClient.csCentreID));
      // Sort out the client's areas of interest based on the provider type
      const aoi_clienttype = areasOfInterestReference.filter((area) => area.providertype === providerType);
      const aoi = aoi_clienttype.filter(({ issue }) => thisClient.clientAreasOfInterest.includes(issue));
      // Sort out the client's program population based on the available options
      const programPopulation = programPopulationOptions.filter(({ name }) => thisClient.programpopulation.includes(name));
      const program = programs.find((v) => v.id === thisClient.programid);

      // Set variable to store client
      const preparedClient = {
        ...thisClient,
        clientAreasOfInterest: aoi,
        programpopulation: programPopulation,
        providerType: providerType,
        ownerName: owner ? owner.fullname : "",
        ownerEmail: owner ? owner.email : "",
        ownerPhone: owner ? owner.mobilephone : "",
        ownerFirstName: owner ? owner.firstname : "",
        program: program ? program : initProgram,
        csCentreName: csCentre ? csCentre.centerName : "",
        csCentrePhone: csCentre ? csCentre.phone : "",
        csCentreID: csCentre ? csCentre.id : null,
      };

      setFormClient(preparedClient);

      // Set a few parameters
      setcurrentOwnerFirstName(owner ? owner.firstname : "");

      // Go to the selected tab if provided
      if (selectedTab) {
        setKey(selectedTab);
      }

      setShow(true);
    },
    [areasOfInterestReference, providerType, csAgents, csCentres, programs, medicalPractitioners, loadMedicalPractitioner],
  );

  useEffect(() => {
    if (client && client.id && client.id > 0) {
      loadProfile(client, filters.clientsListLoadModalID);

      dispatch(
        Admin.actions.setFilters({
          filterName: "clientsListLoadModalID",
          filterValue: undefined,
        }),
      );
    }
  }, [client, loadProfile, filters.clientsListLoadModalID, dispatch]);

  var [currentClientID, setcurrentClientID] = useState();
  var [currentMedicalPractitionerID, setcurrentMedicalPractitionerID] = useState();
  var [currentPaymentType, setcurrentPaymentType] = useState();
  var [currentClientBookingType, setcurrentClientBookingType] = useState();
  var [currentTimeZone, setcurrentTimeZone] = useState();
  var [currentID, setcurrentID] = useState();
  var [currentFirstName, setcurrentFirstName] = useState();
  var [currentPreferredName, setcurrentPreferredName] = useState();
  var [currentSurname, setcurrentSurname] = useState();

  var [currentEmail, setcurrentEmail] = useState();
  var [currentMobile, setcurrentMobile] = useState();
  var [currentAppointmentType, setcurrentAppointmentType] = useState("0");
  var [currentProviderType, setcurrentProviderType] = useState();
  var [currentBusinessName, setcurrentBusinessName] = useState();
  var [currentABN, setcurrentABN] = useState();
  var [currentBusinessAddress, setcurrentBusinessAddress] = useState();
  var [currentBackgroundInformation, setcurrentBackgroundInformation] = useState();
  var [currentHealthCareCard, setcurrentHealthCareCard] = useState();
  var [currentUnemployed, setcurrentUnemployed] = useState();
  var [currentGPMentalHealthPlan12Months, setcurrentGPMentalHealthPlan12Months] = useState();
  var [currentNaturalDisaster, setcurrentNaturalDisaster] = useState();
  var [currentBulkBilledReason, setcurrentBulkBilledReason] = useState();
  const [currentReferralGPPracticeFax, setcurrentReferralGPPracticeFax] = useState();
  const [currentHandOverNotes, setcurrentHandOverNotes] = useState();
  const [currentAction, setcurrentAction] = useState("None");
  const [currentProgramPopulation, setcurrentProgramPopulation] = useState([]);
  const [currentProgram, setcurrentProgram] = useState(false);
  const [currentContractProviderFee, setcurrentContractProviderFee] = useState();
  const [currentRHCContractManagedLabel, setcurrentRHCContractManagedLabel] = useState(false);
  const [currentNthQLDPHNPast, setcurrentNthQLDPHNPast] = useState();
  const [currentNthQLDPHNTotal, setcurrentNthQLDPHNTotal] = useState();
  const [currentNthQLDPHNFuture, setcurrentNthQLDPHNFuture] = useState();
  // Centralised Service Fields
  var [currentSpecialistType, setcurrentSpecialistType] = useState();

  // Centralised Service Contact
  var [currentOwnerFirstName, setcurrentOwnerFirstName] = useState("");

  const [key, setKey] = React.useState("Personal");

  var [showBooking, setShowBooking] = useState(false);
  var [showConfirmation, setShowConfirmation] = useState(false);
  var [booking, setBooking] = useState(false);
  var [toggleMessage, setToggleMessage] = useState(false);
  var [newNote, setNewNote] = useState("");
  var [sentMsg, setSentMsg] = useState();
  var [noteAction, setNoteAction] = useState("SMS");
  var [currentNoteViewType, setcurrentNoteViewType] = useState("NoteOnly");

  // Closure Settings
  var [currentClosureProviderStatus, setcurrentClosureProviderStatus] = useState();

  const loadBooking = (thisBooking) => {
    setBooking(thisBooking);
    setNewNote(`Dear ${thisBooking.clientFirstName},

Please note you have been booked for a consultation with ${thisBooking.psychologistfullname} at ${format(new Date(thisBooking.clientDate ? thisBooking.clientDate : null), "dd-MM-yyyy hh:mm aa")}. 

Please connect here: ${thisBooking.waitingroomurl} at that time.`);
    setToggleMessage(false);
    setShowBooking(true);
  };

  function getActionButtons(id) {
    if (booking.status === "Active") {
      return (
        <>
          <Button variant="warning" size="sm" onClick={() => cancelBooking(id)}>
            Cancel Booking
          </Button>
        </>
      );
    }
  }

  function cancelBooking(id) {
    dispatch(
      Admin.actions.putAppointment({
        id: id,
        status: "Cancelled",
        refreshPayload: { key: "psychologist", id: registered.id },
      }),
    );
    setBooking({ ...booking, status: "Cancelled" });
  }

  // function deleteBooking(id) {
  //   dispatch(Admin.actions.putAppointment(
  //     { id: id,
  //       status: 'Deleted',
  //       refreshPayload: { key: 'psychologist', id: registered.id }
  //     }));
  //   setBooking({...booking, status: 'Deleted'});
  //   setShowBooking(false)
  // }

  function sendMessage() {
    const formData = new FormData();
    // Add fields
    formData.append("type", "Client");
    formData.append("pkid", booking.clientID);
    formData.append("subject", "");
    formData.append("selector", "SMS");
    formData.append("note", newNote);
    formData.append("faxdestination", "");
    formData.append("faxFile", "");
    formData.append("sendFormID", 0);
    // Ok Time to Dispatch
    process.env.REACT_APP_DEBUG && console.log(...formData);
    dispatch(
      Admin.actions.postNote({
        formData: formData,
        type: "Client",
        pkID: booking.clientID,
      }),
    );
    setSentMsg("Message sent!");
    showMessageTimer();
  }

  const showMessageTimer = () => {
    const timer = setTimeout(() => {
      setSentMsg(undefined);
      setShowBooking(false);
    }, 3000);
    return () => clearTimeout(timer);
  };

  const loadToDos = (clientID, fullName) => {
    setToDoClientID(clientID);
    setToDoTitle(fullName);
    setShowToDo(true);
  };

  const validationSchema = Yup.object().shape({
    firstname: Yup.string().min(2, "Too Short").max(200, "Too Long").required("First Name is required"),
    preferredname: Yup.string().max(200, "Too Long"),
    surname: Yup.string().min(2, "Too Short").max(200, "Too Long").required("Surname is required"),
    dob: Yup.string().when(["providerType"], {
      is: (providerType) => providerType !== "Supervision",
      then: Yup.string()
        .required("Date of Birth is required")
        .test("dob", "Please enter a valid date", function (value) {
          return differenceInYears(new Date(), new Date(value)) >= 1 && differenceInYears(new Date(), new Date(value)) <= 100;
        }),
    }),
    email: Yup.string().when(["noEmail"], {
      is: (noEmail) => noEmail !== true,
      then: Yup.string()
        .min(2, "Too Short")
        .max(200, "Too Long")
        .email("Enter a valid email")
        .required("Email is required")
        .test("duplicate-email", "This email address is already registered", () => !emailIsDuplicate),
    }),
    mobilephone: Yup.string().min(2, "Too Short").max(12, "Too Long").required("Phone Number is required"),
    fulladdress: Yup.string().min(4, "Too Short").max(80, "Too Long").required("Address is required"),
    pronouns: Yup.string().max(20, "Too Long"),
    hopeToGetFromTreatment: Yup.string().max(4000, "Too Long"),
    emergencycontactname1: Yup.string()
      .when(["providerType"], {
        is: (providerType) => providerType === "ALL",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Psychologist",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Clinical",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Provisional",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Social",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Nurse",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Occupational",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "EAP",
        then: Yup.string().min(1, "Too Short").max(100, "Too Long").required("Emergency Contact  is required"),
      }),
    emergencycontactrelation1: Yup.string()
      .when(["providerType"], {
        is: (providerType) => providerType === "ALL",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Psychologist",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Clinical",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Provisional",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Social",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Nurse",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Occupational",
        then: Yup.string().min(1, "Too Short").max(50, "Too Long").required("Emergency Contact Relationship is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "EAP",
        then: Yup.string().min(1, "Too Short").max(20, "Too Long").required("Emergency Contact Relationship is required"),
      }),
    emergencycontactphone1: Yup.string()
      .when(["providerType"], {
        is: (providerType) => providerType === "ALL",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Psychologist",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Clinical",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Provisional",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Social",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Nurse",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "Occupational",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      })
      .when(["providerType"], {
        is: (providerType) => providerType === "EAP",
        then: Yup.string().min(6, "Too Short").max(20, "Too Long").required("Emergency Contact phone number is required"),
      }),
    emergencycontactname2: Yup.string()
      .nullable()
      .when("providerType", {
        is: (providerType) => ["ALL", "Psychologist", "Clinical", "Provisional", "Social", "Nurse", "Occupational", "EAP"].includes(providerType),
        then: Yup.string()
          .nullable()
          .test("max-length", "Too Long", (value) => !value || value.length <= 100),
      }),

    emergencycontactrelation2: Yup.string()
      .nullable()
      .when("providerType", {
        is: (providerType) => ["ALL", "Psychologist", "Clinical", "Provisional", "Social", "Nurse", "Occupational", "EAP"].includes(providerType),
        then: Yup.string()
          .nullable()
          .test("max-length", "Too Long", (value) => !value || value.length <= 50),
      }),

    emergencycontactphone2: Yup.string()
      .nullable()
      .when("providerType", {
        is: (providerType) => ["ALL", "Psychologist", "Clinical", "Provisional", "Social", "Nurse", "Occupational", "EAP"].includes(providerType),
        then: Yup.string()
          .nullable()
          .test("min-length", "Too Short", (value) => !value || value.length >= 6)
          .test("max-length", "Too Long", (value) => !value || value.length <= 20),
      }),

    medicarereferenceno: Yup.string().when(["providerType", "contract", "specialisttype"], {
      is: (providerType, contract, specialisttype) =>
        ["ALL", "Psychologist", "Social", "Nurses", "Occupational", "Clinical", "GP"].includes(providerType) &&
        !contract &&
        specialisttype !== "centralisedservice",
      then: (schema) => schema.matches(/^\d$/, "Must be 1 number").required("Medicare Reference Number is required"),
    }),

    medicareexpirydate: Yup.string().when(["providerType", "contract", "specialisttype"], {
      is: (providerType, contract, specialisttype) =>
        ["ALL", "Psychologist", "Social", "Nurse", "Nurses", "Occupational", "Clinical", "GP"].includes(providerType) &&
        !contract &&
        specialisttype !== "centralisedservice",
      then: (schema) => schema.min(5, "Too Short").max(10, "Too Long").required("Medicare Expiry is required"),
    }),

    medicareno: Yup.string().when(["providerType", "contract", "specialisttype"], {
      is: (providerType, contract, specialisttype) =>
        ["ALL", "Psychologist", "Social", "Nurse", "Nurses", "Occupational", "Clinical", "GP"].includes(providerType) &&
        !contract &&
        specialisttype !== "centralisedservice",
      then: (schema) =>
        schema
          .min(10, "Too Short")
          .max(10, "Too Long")
          .required("Medicare Card Number is required")
          .test("cardValid", "A Valid Medicare Number is required", (value) => (value ? validateMedicareNumber(value) : false)),
    }),

    ndisnumber: Yup.string().when(["providerType"], {
      is: (providerType) => providerType === "NDIS",
      then: Yup.string().min(3, "Too Short").max(50, "Too Long").required("NDIS Number is required"),
    }),
  });

  const columns = [
    { field: "id", headerName: "ID", hide: true },
    {
      field: "fullname",
      headerName: "Name",
      width: 250,
      renderCell: (params) => (
        <Grid container justifyContent="space-between">
          <Grid item onClick={() => loadClient(params.row.id)} className="cell-Link">
            <strong>{params.value}</strong>
          </Grid>
          <Grid item>
            <Badge
              variant={params.row.toDoCount === 0 ? "secondary" : params.row.toDoWarning ? "warning" : "success"}
              onClick={() => loadToDos(params.row.id, params.value)}
              style={{ marginRight: 2, cursor: "pointer", minWidth: 21 }}
            >
              {params.row.toDoCount}
              {/* {params.row.toDoCount === 0 ?
                  <NoteAddIcon style={{ marginLeft: 8, color: 'green' }}  />
                : params.row.toDoCount } */}
            </Badge>
          </Grid>
        </Grid>
        // <strong>
        //   <div onClick={() => loadClient(params.row.id)} className="cell-Link">
        //     {params.value}
        //   </div>
        // </strong>
      ),
    },
    { field: "email", headerName: "Email/Username", width: 230 },
    { field: "mobilephone", headerName: "Phone", width: 120 },
    // { field: 'medicareisvalid', headerName: 'Medicare', width: 130 },
    {
      field: "createdon",
      type: "date",
      headerName: "Created",
      width: 120,
      hide: true,
    },
    {
      field: "nextBookingID",
      headerName: "Next Booking ID",
      width: 120,
      hide: true,
    },
    { field: "status", headerName: "Status", width: 100, hide: true },
    {
      field: "topBookingPsy",
      type: "date",
      headerName: "Booking",
      width: 140,
      // valueFormatter: ({ value }) => value ? format(new Date(value), "dd-MM-yyyy HH:mm") : null,
      cellClassName: (params) => (params.row.nextBookingID !== null ? "future-booking" : null),
      renderCell: (params) => (
        <>
          {bookings && params.row.nextBookingID ? (
            <div onClick={() => loadBooking(bookings.find((r) => r.id === params.row.nextBookingID))} className="cell-Link">
              {format(new Date(params.row.topBookingPsy), "dd-MM-yyyy HH:mm")}
            </div>
          ) : params.row.topBookingPsy != null ? (
            format(new Date(params.row.topBookingPsy), "dd-MM-yyyy HH:mm")
          ) : null}
        </>
      ),
    },
    { field: "fileCount", headerName: "File Count", width: 120, hide: true },
    { field: "totalbookings", headerName: "Bookings", width: 125, hide: false },
    { field: "files", headerName: "Files", width: 120, hide: true },
    {
      field: "none",
      headerName: "Actions",
      width: 440,
      renderCell: (params) => (
        <>
          <Button
            variant="warning"
            size="sm"
            style={{
              color: "black",
              fontWeight: 500,
              border: "1px solid rgb(192 192 192)",
              background: "#ede9fe",
              marginRight: 10,
            }}
            onClick={() =>
              loadNoteOnly(
                clients.find((client) => client.id === params.row.id),
                "Note",
              )
            }
          >
            Notes
          </Button>

          {params.row.mobilephone.substring(0, 2) === "04" ? (
            <Button
              variant="secondary"
              size="sm"
              style={{
                color: "black",
                fontWeight: 500,
                border: "1px solid rgb(192 192 192)",
                background: "#faefcf",
                marginRight: 10,
              }}
              onClick={() =>
                loadNotes(
                  clients.find((client) => client.id === params.row.id),
                  "SMS",
                )
              }
            >
              SMS
            </Button>
          ) : null}
          {params.row.email.substring(0, 2) !== "04" ? (
            <Button
              variant="secondary"
              size="sm"
              style={{
                color: "black",
                fontWeight: 500,
                border: "1px solid rgb(192 192 192)",
                background: "#d2f9fa",
                marginRight: 10,
              }}
              onClick={() =>
                loadNotes(
                  clients.find((client) => client.id === params.row.id),
                  "Email",
                )
              }
            >
              Email
            </Button>
          ) : null}
          <Button
            variant="secondary"
            size="sm"
            style={{
              color: "black",
              fontWeight: 500,
              border: "1px solid rgb(192 192 192)",
              background: "#ebfae8",
              marginRight: 10,
            }}
            onClick={() => loadFiles(clients.find((client) => client.id === params.row.id))}
          >
            Files
          </Button>
          <Button
            variant="secondary"
            size="sm"
            style={{
              color: "black",
              fontWeight: 500,
              border: "1px solid rgb(192 192 192)",
              background: "#fff0ed",
              marginRight: 10,
            }}
            onClick={() =>
              loadNotes(
                clients.find((client) => client.id === params.row.id),
                "Fax",
              )
            }
          >
            Fax
          </Button>
          {(params.row.status === "Active" || params.row.status === "Closed") && params.row.specialisttype === "centralisedservice" ? (
            <Button
              variant="secondary"
              size="sm"
              style={{
                color: "black",
                fontWeight: 500,
                border: "1px solid rgb(192 192 192)",
                background: "#ffff00",
                marginRight: 10,
              }}
              onClick={() =>
                loadCSComplete(
                  clients.find((client) => client.id === params.row.id),
                  "Complete",
                )
              }
            >
              Complete
            </Button>
          ) : (
            <>
              {(params.row.status === "Active" || params.row.status === "Closed") && params.row.specialisttype !== "centralisedservice" ? (
                <Button
                  variant="secondary"
                  size="sm"
                  style={{
                    color: "black",
                    fontWeight: 500,
                    border: "1px solid rgb(192 192 192)",
                    background: "#ffff00",
                    marginRight: 10,
                  }}
                  onClick={() =>
                    loadArchive(
                      clients.find((client) => client.id === params.row.id),
                      "Archived",
                    )
                  }
                >
                  Archive
                </Button>
              ) : (
                <>
                  {params.row.specialisttype !== "centralisedservice" && (
                    <Button
                      variant="secondary"
                      size="sm"
                      style={{
                        color: "black",
                        fontWeight: 500,
                        border: "1px solid rgb(192 192 192)",
                        background: "#ffff00",
                        marginRight: 10,
                      }}
                      onClick={() =>
                        loadArchive(
                          clients.find((client) => client.id === params.row.id),
                          "Active",
                        )
                      }
                    >
                      UnArchive
                    </Button>
                  )}
                </>
              )}
            </>
          )}
        </>
      ),
    },
  ];

  const handleSearch = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);
  };

  return (
    <>
      <Paper>
        <Grid container style={{ padding: 10 }}>
          <Grid
            item
            style={{
              paddingTop: 8,
              paddingRight: 50,
              paddingLeft: 4,
              color: "#646c9a",
            }}
          >
            <h4>Clients</h4>
          </Grid>
          <Grid item style={{ marginTop: 2, paddingRight: 10 }}>
            <InputGroup size="sm">
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <SearchIcon fontSize="small" style={{ marginLeft: -4 }} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control type="text" value={searchTerm} onChange={(event) => handleSearch(event)} autoComplete="OFF" style={{ height: 37, maxWidth: 200 }} />
            </InputGroup>
          </Grid>
          <Grid item style={{ marginTop: 2, paddingRight: 10 }}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="clientsStatus-label" className={classes.label}>
                Status
              </InputLabel>
              <Select
                labelId="clientsStatus-label"
                id="clientsStatus"
                margin="dense"
                style={{ minWidth: 120, backgroundColor: "#ffffff" }}
                value={filters.clientsStatus}
                onChange={(event) =>
                  dispatch(
                    Admin.actions.setFilters({
                      filterName: "clientsStatus",
                      filterValue: event.target.value,
                    }),
                  )
                }
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="CSComplete">CS - Complete</MenuItem>
                <MenuItem value="Closed">Closed</MenuItem>
                <MenuItem value="Archived">Archived</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>

      <Paper style={{ height: 700 }}>
        <DataGridPro
          rows={filteredClients}
          columns={columns}
          pagination={false}
          checkboxSelection={false}
          sortModel={[{ field: "topBookingPsy", sort: "desc" }]}
          getRowClassName={(params) => `datagrid-row-clients-${params.row.isNewClient.toString()}`}
        />
      </Paper>

      {/* {currentRHCNDISManagedLabel ? <span style={{ marginLeft:40, color: 'blue' }}>Managed by RHC. Provider payment per session ${currentNDISActualProviderFee}</span>  : null}  */}

      <Modal show={show} onHide={() => setShow(false)} dialogClassName="editprofile-modal">
        <Formik
          enableReinitialize={true}
          initialValues={formClient || initClient}
          validationSchema={validationSchema}
          onSubmit={(values, actions) => {
            putClient(values);
            // actions.setSubmitting(false);
          }}
        >
          {(props) => {
            const { values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, setFieldTouched } = props;
            const change = (name, e) => {
              e.persist();
              handleChange(e);
            };

            return (
              <form noValidate={true} autoComplete="off" onSubmit={handleSubmit}>
                <Modal.Header closeButton className="editprofile-modal">
                  <Modal.Title>
                    Edit Profile - {values.firstname} {values.surname}
                    {currentRHCContractManagedLabel ? (
                      <span style={{ marginLeft: 40, color: "blue" }}>Managed by RHC. Provider payment per session ${currentContractProviderFee}</span>
                    ) : null}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body className="editprofile-modal">
                  <Tabs id="EditModal" activeKey={key} onSelect={(k) => setKey(k)} mountOnEnter={true}>
                    <Tab eventKey="Personal" title="Personal" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                      {values.specialisttype === "centralisedservice" ? (
                        <>
                          <Row>
                            <h5 style={{ marginBottom: "25px" }}>Centralised Service Information</h5>
                          </Row>
                          <Row style={{ marginBottom: "20px" }}>
                            <Col md="3">
                              <div className="text">Estimated End of Care Date</div>
                              <div style={{ fontSize: "1.1rem" }}>{values.estimatedEndOfCareDate || "-"}</div>
                            </Col>
                            <Col md="3">
                              <div className="text">Future Sessions</div>
                              <div style={{ fontSize: "1.1rem" }}>{values.futureSessions ?? "-"}</div>
                            </Col>
                            <Col md="3">
                              <div className="text">Attended Bookings</div>
                              <div style={{ fontSize: "1.1rem" }}>{values.attendedSessions ?? "-"}</div>
                            </Col>
                            <Col md="3">
                              <div className="text">Cancelled Bookings</div>
                              <div style={{ fontSize: "1.1rem" }}>{values.cancelledSessions ?? "-"}</div>
                            </Col>
                          </Row>{" "}
                          <Row>
                            <Col md="6">
                              <Form.Group style={{ width: "100%" }}>
                                <Form.Label>Centre contact</Form.Label>
                                <Form.Control type="text" name="ownerName" value={values.ownerName} readOnly style={{ backgroundColor: "#e9ecef" }} />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group style={{ width: "100%" }}>
                                <Form.Label>Contact Email</Form.Label>
                                <Form.Control type="text" name="ownerEmail" value={values.ownerEmail} readOnly style={{ backgroundColor: "#e9ecef" }} />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group style={{ width: "100%" }}>
                                <Form.Label>Contact Phone</Form.Label>
                                <Form.Control type="text" name="ownerPhone" value={values.ownerPhone} readOnly style={{ backgroundColor: "#e9ecef" }} />
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="6">
                              <Form.Group style={{ width: "100%" }}>
                                <Form.Label>Centre</Form.Label>
                                <Form.Control type="text" name="csCentreName" value={values.csCentreName} readOnly style={{ backgroundColor: "#e9ecef" }} />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group style={{ width: "100%" }}>
                                <Form.Label>Centre Phone</Form.Label>
                                <Form.Control type="text" name="csCentrePhone" value={values.csCentrePhone} readOnly style={{ backgroundColor: "#e9ecef" }} />
                              </Form.Group>
                            </Col>
                          </Row>
                          <hr />
                        </>
                      ) : null}
                      <Row>
                        <h5 style={{ marginTop: "20px", marginBottom: "25px" }}>Personal Information</h5>
                      </Row>

                      <Row>
                        <Col md="3">
                          <Form.Group>
                            <Form.Label>First Name*</Form.Label>
                            <Form.Control
                              type="text"
                              name="firstname"
                              value={values.firstname}
                              onChange={handleChange}
                              autoComplete="new-password"
                              isInvalid={touched.firstname && !!errors.firstname}
                              isValid={touched.firstname && !errors.firstname}
                            />
                            <Form.Control.Feedback type="invalid">{errors.firstname}</Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md="3">
                          <Form.Group>
                            <Form.Label>Preferred Name</Form.Label>
                            <Form.Control
                              type="text"
                              name="preferredname"
                              value={values.preferredname}
                              onChange={handleChange}
                              autoComplete="new-password"
                              isInvalid={touched.preferredname && !!errors.preferredname}
                              isValid={touched.preferredname && !errors.preferredname}
                            />
                            <Form.Control.Feedback type="invalid">{errors.preferredname}</Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md="3">
                          <Form.Group>
                            <Form.Label>Surname*</Form.Label>
                            <Form.Control
                              type="text"
                              name="surname"
                              value={values.surname}
                              onChange={handleChange}
                              autoComplete="new-password"
                              isInvalid={touched.surname && !!errors.surname}
                              isValid={touched.surname && !errors.surname}
                            />
                            <Form.Control.Feedback type="invalid">{errors.surname}</Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                        <Col md="3">
                          <Form.Group>
                            <Form.Label>Pronouns</Form.Label>
                            <Form.Control
                              type="text"
                              name="pronouns"
                              value={values.pronouns}
                              onChange={handleChange}
                              autoComplete="new-password"
                              isInvalid={touched.pronouns && !!errors.pronouns}
                              isValid={touched.pronouns && !errors.pronouns}
                            />
                            <Form.Control.Feedback type="invalid">{errors.pronouns}</Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        {currentProviderType !== "Supervision" ? (
                          <Col md="3">
                            <Form.Group>
                              <Form.Label>Gender*</Form.Label>
                              <Form.Control as="select" name="gender" value={values.gender} onChange={handleChange}>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                                <option value="Other">Other</option>
                                <option value="Prefer not to say">Prefer not to say</option>
                              </Form.Control>
                            </Form.Group>
                          </Col>
                        ) : null}
                        {currentProviderType !== "Supervision" ? (
                          <Col md="3">
                            <Form.Group>
                              <Form.Label>Date of Birth*</Form.Label>
                              <Form.Control
                                type="date"
                                name="dob"
                                value={values.dob}
                                onChange={handleChange}
                                autoComplete="new-password"
                                isInvalid={touched.dob && !!errors.dob}
                                isValid={touched.dob && !errors.dob}
                              />
                              <Form.Control.Feedback type="invalid">{errors.dob}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        ) : null}
                        <Col md="6">
                          <Form.Group style={{ width: "100%" }}>
                            <Form.Label>TimeZone*</Form.Label>
                            <Autocomplete
                              id="profileTimeZone"
                              variant="outlined"
                              options={timeZone}
                              getOptionLabel={(option) => option.name}
                              value={timeZone.find((v) => v.systemName === values.timeZone) || ""}
                              onChange={(event, newValue) => setFieldValue("timeZone", newValue ? newValue.systemName : "")}
                              style={{
                                fullWidth: true,
                                display: "flex",
                                wrap: "nowrap",
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  type="text"
                                  variant="outlined"
                                  margin="dense"
                                  name="TimeZoneSelector"
                                  style={{
                                    backgroundColor: "white",
                                    margin: 0,
                                    padding: 0,
                                  }}
                                  inputProps={{
                                    ...params.inputProps,
                                    autoComplete: "new-password",
                                  }}
                                />
                              )}
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <Form.Group>
                            <Form.Label>Email * </Form.Label>
                            <Form.Control
                              type="text"
                              name="email"
                              value={values.email}
                              onChange={(e) => {
                                setEmailIsDuplicate(false);
                                change("email", e);
                              }}
                              onBlur={(e) => {
                                handleBlur(e);
                                if (e.currentTarget.value && e.currentTarget.value.length > 0) {
                                  dispatch(Registration.actions.emailDuplicate(e.currentTarget.value));
                                }
                              }}
                              isInvalid={touched.email && !!errors.email}
                              isValid={touched.email && !errors.email}
                              autoComplete="new-password"
                            />
                            <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>{" "}
                          </Form.Group>
                        </Col>

                        <Col md="3">
                          <Form.Group>
                            <Form.Label>Contact Phone Number*</Form.Label>
                            <Form.Control
                              type="text"
                              name="mobilephone"
                              value={values.mobilephone}
                              onChange={handleChange}
                              autoComplete="new-password"
                              isInvalid={touched.mobilephone && !!errors.mobilephone}
                              isValid={touched.mobilephone && !errors.mobilephone}
                            />
                            <Form.Control.Feedback type="invalid">{errors.mobilephone}</Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <Form.Group style={{ width: "100%" }}>
                            <Form.Label>Home Address (start typing to search) *</Form.Label>
                            <PlacesAutoComplete
                              currentID={values.id}
                              currentfulladdress={values.fulladdress}
                              setcurrentfulladdress={(value) => {
                                setFieldValue("fulladdress", value, true);
                                setFieldTouched("fulladdress", true, true);
                              }}
                              setcurrentLatitude={(value) => setFieldValue("latitude", value)}
                              setcurrentLongitude={(value) => setFieldValue("longitude", value)}
                              setcurrentPostCode={(value) => setFieldValue("postCode", value)}
                              isInvalid={touched.fulladdress && !!errors.fulladdress}
                              isValid={touched.fulladdress && !errors.fulladdress}
                            />
                            {touched.fulladdress && !!errors.fulladdress ? <p className="error-help">{errors.fulladdress}</p> : ""}
                          </Form.Group>
                        </Col>
                        {values.providerType !== "Supervision" && values.specialisttype !== "centralisedservice" ? (
                          <Col md="3">
                            <Form.Group>
                              <Form.Label>Occupation</Form.Label>
                              <Form.Control type="text" name="occupation" value={values.occupation} onChange={handleChange} autoComplete="new-password" />
                            </Form.Group>
                          </Col>
                        ) : null}
                      </Row>
                      <Row>
                        <Col md="6">
                          <Form.Group>
                            <Form.Label>Do you identify as Aboriginal and/or Torres Strait islander</Form.Label>
                            <Form.Control as="select" name="indigenous" value={values.indigenous} onChange={handleChange}>
                              <option value="N">No</option>
                              <option value="Y">Yes</option>
                            </Form.Control>
                          </Form.Group>
                        </Col>
                      </Row>
                      <Row>
                        {values.providerType !== "Financial" && values.providerType !== "Supervision" ? (
                          <>
                            <Col md="3">
                              <Form.Group style={{ width: "100%" }}>
                                <Form.Label>Funding Type*</Form.Label>
                                {values.specialisttype === "centralisedservice" ? (
                                  <Form.Control
                                    type="text"
                                    name="paymentType"
                                    value={values.paymentType || ""}
                                    readOnly
                                    style={{
                                      backgroundColor: "#e9ecef",
                                      cursor: "default",
                                    }}
                                  />
                                ) : (
                                  <Form.Control as="select" name="paymentType" value={values.paymentType} onChange={handleChange}>
                                    <option value="Bulk Billed">Bulk Billed</option>
                                    <option value="Reduced Gap">Reduced Gap</option>
                                    <option value="Full Fee">Full Fee</option>
                                    <option value="NDIS">NDIS</option>
                                    <option value="Contract" disabled>
                                      Contract
                                    </option>
                                    <option value="EAP" disabled>
                                      EAP
                                    </option>
                                    <option value="TAC" disabled>
                                      Transport Accident Commmission
                                    </option>
                                    <option value="WorkCover" disabled>
                                      Work Cover
                                    </option>
                                    <option value="DVA" disabled>
                                      Department of Veterans` Affairs
                                    </option>
                                    <option value="Island">Island (Cocos and Christmas Islands)</option>
                                  </Form.Control>
                                )}
                              </Form.Group>
                            </Col>{" "}
                            {values.paymentType === "Contract" ? (
                              <Col md="3">
                                <Form.Group>
                                  <Form.Label>Specialist Type</Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={values.specialisttype === "centralisedservice" ? "Centralised Service" : values.specialisttype}
                                    readOnly
                                    style={{ backgroundColor: "#e9ecef" }}
                                  />
                                </Form.Group>
                              </Col>
                            ) : null}
                            {values.specialisttype !== "centralisedservice" ? (
                              <>
                                <Col md="6">
                                  <Form.Group style={{ width: "100%" }}>
                                    <Form.Label>Program (Set by RHC Admin)</Form.Label>
                                    <Autocomplete
                                      id="ProgramID"
                                      variant="outlined"
                                      options={programs}
                                      getOptionLabel={(option) => option.name}
                                      getOptionSelected={(option, value) => getProgramOption(option, value)}
                                      value={values.program}
                                      style={{
                                        fullWidth: true,
                                        display: "flex",
                                        wrap: "nowrap",
                                        cursor: "default",
                                        backgroundColor: "#e9ecef",
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          type="text"
                                          variant="outlined"
                                          margin="dense"
                                          name="programID"
                                          style={{
                                            backgroundColor: "",
                                            margin: 0,
                                            padding: 0,
                                          }}
                                          inputProps={{
                                            ...params.inputProps,
                                            autoComplete: "new-password",
                                          }}
                                          disabled
                                        />
                                      )}
                                    />
                                  </Form.Group>
                                </Col>
                              </>
                            ) : null}
                          </>
                        ) : null}
                        {values.paymentType === "Contract" || values.paymentType === "EAP" ? (
                          <Col md="2">
                            <Form.Group>
                              <Form.Label>Contract Provider Fee</Form.Label>
                              <Form.Control
                                type="text"
                                name="contractproviderfee"
                                value={values.contractproviderfee}
                                readOnly
                                style={{ backgroundColor: "#e9ecef" }}
                              />
                            </Form.Group>
                          </Col>
                        ) : null}
                      </Row>
                      {values.specialisttype === "centralisedservice" ? (
                        <>
                          <Row>
                            <Col md="4">
                              <Form.Group>
                                <Form.Label>Translator Required</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={values.translator || ""}
                                  readOnly
                                  style={{
                                    backgroundColor: "#e9ecef",
                                    cursor: "default",
                                  }}
                                />
                              </Form.Group>
                            </Col>{" "}
                            {values.translator === "Yes" ? (
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Language</Form.Label>
                                  <Form.Control type="text" name="profiletranslatorLanguage" value={values.translatorLanguage} readOnly />
                                </Form.Group>
                              </Col>
                            ) : null}
                          </Row>
                          <Row>
                            <Col md="4">
                              <Form.Group>
                                <Form.Label>Support Person Required *</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={values.supportPerson || ""}
                                  readOnly
                                  style={{
                                    backgroundColor: "#e9ecef",
                                    cursor: "default",
                                  }}
                                />
                              </Form.Group>
                            </Col>
                            {values.supportPerson === "Yes" ? (
                              <Col md="6">
                                <Form.Group>
                                  <Form.Label>Type of support person</Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="profilesupportPersonDetail"
                                    value={values.profilesupportPersonDetail}
                                    readOnly
                                    style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                  />
                                </Form.Group>
                              </Col>
                            ) : null}
                          </Row>
                        </>
                      ) : null}
                      {values.paymentType === "Contract" || values.paymentType === "EAP" ? (
                        <>
                          {values.specialisttype === "nthqldphn" ? (
                            <>
                              <Row>
                                <Col md="12">
                                  <Form.Label style={{ color: "green", fontWeight: 500 }}>Nth QLD PHN Booking Management for this client</Form.Label>
                                </Col>
                              </Row>
                              <Row>
                                <Col md="2">
                                  <Form.Group>
                                    <Form.Label>Estimated Total</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="nthQLDPHNEstimated"
                                      value={values.nthQLDPHNEstimated}
                                      onChange={handleChange}
                                      autoComplete="new-password"
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md="2">
                                  <Form.Group>
                                    <Form.Label>Total To Date</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="profileNthQLDPHNTotal"
                                      defaultValue={currentNthQLDPHNTotal}
                                      readOnly
                                      style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md="2">
                                  <Form.Group>
                                    <Form.Label>Past Bookings</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="profileNthQLDPHNPast"
                                      defaultValue={currentNthQLDPHNPast}
                                      readOnly
                                      style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md="2">
                                  <Form.Group>
                                    <Form.Label>Future Bookings</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="profileNthQLDPHNFuture"
                                      defaultValue={currentNthQLDPHNFuture}
                                      readOnly
                                      style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>
                            </>
                          ) : null}
                        </>
                      ) : null}
                      {programPopulationOptions && currentProgram ? (
                        <Row>
                          <Col md="12">
                            <Form.Group>
                              <Form.Label>
                                Do you identify as any of the following populations that we are particularly supporting via this program? (select all that
                                apply)
                              </Form.Label>
                              <Row>
                                <Col md="6">
                                  <List className={classes.root}>
                                    {programPopulationOptions.map((row) => {
                                      if (row.index <= programPopulationOptions.length / 2) {
                                        const labelId = `checkbox-list-label-${row.id}`;
                                        var isChecked = (values.programPopulation || []).find((r) => r.id === row.id);
                                        return (
                                          <ListItem
                                            key={row.id}
                                            role={undefined}
                                            dense
                                            button
                                            onClick={() => {
                                              const current = values.programPopulation || [];
                                              const exists = current.some((r) => r.id === row.id);
                                              setFieldValue("programPopulation", exists ? current.filter((r) => r.id !== row.id) : [...current, row]);
                                            }}
                                          >
                                            <ListItemIcon style={{ minWidth: 40 }}>
                                              <Checkbox
                                                edge="start"
                                                checked={isChecked !== undefined}
                                                tabIndex={-1}
                                                disableRipple
                                                inputProps={{
                                                  "aria-labelledby": labelId,
                                                }}
                                              />
                                            </ListItemIcon>
                                            <ListItemText
                                              id={labelId}
                                              style={{ fontSize: 12 }}
                                              disableTypography
                                              primary={
                                                <Typography className={isChecked !== undefined ? classes.linkSelected : classes.link}>{row.name}</Typography>
                                              }
                                              className={classes.link}
                                            />
                                          </ListItem>
                                        );
                                      } else {
                                        return null;
                                      }
                                    })}
                                  </List>
                                </Col>
                                <Col md="6">
                                  <List className={classes.root}>
                                    {programPopulationOptions.map((row) => {
                                      if (row.index > programPopulationOptions.length / 2) {
                                        const labelId = `checkbox-list-label-${row.id}`;
                                        var isChecked = (values.programPopulation || []).find((r) => r.id === row.id);
                                        return (
                                          <ListItem
                                            key={row.id}
                                            role={undefined}
                                            dense
                                            button
                                            onClick={() => {
                                              const current = values.programPopulation || [];
                                              const exists = current.some((r) => r.id === row.id);
                                              setFieldValue("programPopulation", exists ? current.filter((r) => r.id !== row.id) : [...current, row]);
                                            }}
                                          >
                                            <ListItemIcon style={{ minWidth: 40 }}>
                                              <Checkbox
                                                edge="start"
                                                checked={isChecked !== undefined}
                                                tabIndex={-1}
                                                disableRipple
                                                inputProps={{
                                                  "aria-labelledby": labelId,
                                                }}
                                              />
                                            </ListItemIcon>
                                            <ListItemText
                                              id={labelId}
                                              style={{ fontSize: 12 }}
                                              disableTypography
                                              primary={
                                                <Typography className={isChecked !== undefined ? classes.linkSelected : classes.link}>{row.name}</Typography>
                                              }
                                              className={classes.link}
                                            />
                                          </ListItem>
                                        );
                                      } else {
                                        return null;
                                      }
                                    })}
                                  </List>
                                </Col>
                              </Row>
                            </Form.Group>
                          </Col>
                        </Row>
                      ) : null}
                      {values.providerType !== "GP" && values.providerType !== "Supervision" && values.specialisttype !== "centralisedservice" ? (
                        <>
                          <Row>
                            <Col md="12">
                              <Form.Group>
                                <Form.Label>Areas of Interest (Select all that apply) </Form.Label>
                                <Autocomplete
                                  id="searchAOI"
                                  variant="outlined"
                                  multiple
                                  options={areasOfInterest}
                                  getOptionLabel={(option) => option.issue}
                                  value={values.clientAreasOfInterest || []}
                                  onChange={(event, newValue) => setFieldValue("clientAreasOfInterest", newValue)}
                                  style={{
                                    fullWidth: true,
                                    display: "flex",
                                    wrap: "nowrap",
                                    backgroundColor: "white",
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      type="text"
                                      variant="outlined"
                                      margin="dense"
                                      name="AOISelector"
                                      style={{
                                        backgroundColor: "",
                                        margin: 0,
                                        padding: 0,
                                      }}
                                      inputProps={{
                                        ...params.inputProps,
                                        autoComplete: "new-password",
                                      }}
                                    />
                                  )}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                        </>
                      ) : null}
                      {values.specialisttype !== "centralisedservice" ? (
                        <Row>
                          <Col md="12">
                            <Form.Group>
                              {values.providerType !== "Supervision" ? (
                                <>
                                  <Form.Label>What are you hoping to get out of your sessions?</Form.Label>
                                </>
                              ) : (
                                <Form.Label>
                                  Details on the type of supervision you are after, where you are currently practicing and other relevant information.
                                </Form.Label>
                              )}
                              <Form.Control
                                as="textarea"
                                rows={4}
                                type="text"
                                name="hopeToGetFromTreatment"
                                value={values.hopeToGetFromTreatment}
                                onChange={handleChange}
                                autoComplete="new-password"
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      ) : null}
                      {values.handOverNotes && values.handOverNotes.length > 2 ? (
                        <Row>
                          <Col md="12">
                            <Form.Group>
                              <Form.Label>Handover Notes </Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={4}
                                type="text"
                                name="profilehandOverNotes"
                                readOnly
                                defaultValue={values.handOverNotes}
                                style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      ) : null}
                      {/* <Row>
                    <Col md="10">
                      <Form.Group controlId="currentMedicalPractitioner.address">
                        <Form.Label>Address - may need to add this </Form.Label>
                          <Form.Control type="text" name="address" value={currentMedicalPractitioner ? currentMedicalPractitioner.address : ''} readOnly />
                      </Form.Group>
                    </Col>
                  </Row> */}
                      {currentProviderType === "Financial" ? (
                        <>
                          <Row>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>Business Name</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="businessName"
                                  readOnly
                                  value={values.businessName || ""}
                                  style={{ backgroundColor: "#e9ecef" }}
                                />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>ABN</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="abn"
                                  readOnly
                                  value={values.abn || ""}
                                  style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                />
                              </Form.Group>
                            </Col>
                            <Col md="6">
                              <Form.Group>
                                <Form.Label>Business Address</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="businessAddress"
                                  readOnly
                                  value={values.businessAddress || ""}
                                  style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12">
                              <Form.Group>
                                <Form.Label>Background Information</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={4}
                                  type="text"
                                  readOnly
                                  name="backgroundinformation"
                                  value={values.backgroundInformation}
                                  autoComplete="new-password"
                                  style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                        </>
                      ) : null}

                      {currentProviderType !== "Financial" && currentProviderType !== "Supervision" ? (
                        <>
                          <Row>
                            <Col md="4">
                              <Form.Group>
                                <Form.Label>Emergency Contact 1*</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="emergencycontactname1"
                                  value={values.emergencycontactname1 || ""}
                                  onChange={handleChange}
                                  autoComplete="new-password"
                                  isInvalid={touched.emergencycontactname1 && !!errors.emergencycontactname1}
                                  isValid={touched.emergencycontactname1 && !errors.emergencycontactname1}
                                />
                                <Form.Control.Feedback type="invalid">{errors.emergencycontactname1}</Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                            <Col md="4">
                              <Form.Group>
                                <Form.Label>Relationship*</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="emergencycontactrelation1"
                                  value={values.emergencycontactrelation1 || ""}
                                  onChange={handleChange}
                                  autoComplete="new-password"
                                  isInvalid={touched.emergencycontactrelation1 && !!errors.emergencycontactrelation1}
                                  isValid={touched.emergencycontactrelation1 && !errors.emergencycontactrelation1}
                                />
                                <Form.Control.Feedback type="invalid">{errors.emergencycontactrelation1}</Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                            <Col md="4">
                              <Form.Group>
                                <Form.Label>Phone*</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="emergencycontactphone1"
                                  value={values.emergencycontactphone1 || ""}
                                  onChange={handleChange}
                                  autoComplete="new-password"
                                  isInvalid={touched.emergencycontactphone1 && !!errors.emergencycontactphone1}
                                  isValid={touched.emergencycontactphone1 && !errors.emergencycontactphone1}
                                />
                                <Form.Control.Feedback type="invalid">{errors.emergencycontactphone1}</Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="4">
                              <Form.Group>
                                <Form.Label>Emergency Contact 2</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="emergencycontactname2"
                                  value={values.emergencycontactname2 || ""}
                                  onChange={handleChange}
                                  autoComplete="new-password"
                                  isInvalid={touched.emergencycontactname2 && !!errors.emergencycontactname2}
                                  isValid={touched.emergencycontactname2 && !errors.emergencycontactname2}
                                />
                                <Form.Control.Feedback type="invalid">{errors.emergencycontactname2}</Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                            <Col md="4">
                              <Form.Group>
                                <Form.Label>Relationship</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="emergencycontactrelation2"
                                  value={values.emergencycontactrelation2 || ""}
                                  onChange={handleChange}
                                  autoComplete="new-password"
                                  isInvalid={touched.emergencycontactrelation2 && !!errors.emergencycontactrelation2}
                                  isValid={touched.emergencycontactrelation2 && !errors.emergencycontactrelation2}
                                />
                                <Form.Control.Feedback type="invalid">{errors.emergencycontactrelation2}</Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                            <Col md="4">
                              <Form.Group>
                                <Form.Label>Phone</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="emergencycontactphone2"
                                  value={values.emergencycontactphone2 || ""}
                                  onChange={handleChange}
                                  autoComplete="new-password"
                                  isInvalid={touched.emergencycontactphone2 && !!errors.emergencycontactphone2}
                                  isValid={touched.emergencycontactphone2 && !errors.emergencycontactphone2}
                                />
                                <Form.Control.Feedback type="invalid">{errors.emergencycontactphone2}</Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                          </Row>
                        </>
                      ) : null}
                      {values.paymentType === "NDIS" ? (
                        <>
                          <h5 style={{ paddingBottom: 20 }}>Billing Information</h5>
                          <Row>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>NDIS Number</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="ndisnumber"
                                  value={values.ndisnumber || ""}
                                  onChange={handleChange}
                                  autoComplete="new-password"
                                  isInvalid={touched.ndisnumber && !!errors.ndisnumber}
                                  isValid={touched.ndisnumber && !errors.ndisnumber}
                                />
                                <Form.Control.Feedback type="invalid">{errors.ndisnumber}</Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>NDIS Date From</Form.Label>
                                <Form.Control type="date" name="ndisdatefrom" value={values.ndisdatefrom} onChange={handleChange} autoComplete="new-password" />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>To</Form.Label>
                                <Form.Control type="date" name="ndisdateto" value={values.ndisdateto} onChange={handleChange} autoComplete="new-password" />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>NDIS Total Fee</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="ndisbookingfee"
                                  value={values.ndisbookingfee || ""}
                                  onChange={handleChange}
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="6">
                              <Form.Group>
                                <Form.Label>NDIS Plan Management Provider</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="ndisplanmanagementprovider"
                                  value={values.ndisplanmanagementprovider}
                                  onChange={handleChange}
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                            <Col md="6">
                              <Form.Group>
                                <Form.Label>NDIS Invoice Email</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="ndisemailforinvoices"
                                  value={values.ndisemailforinvoices}
                                  onChange={handleChange}
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="6">
                              <Form.Group>
                                <Form.Label>NDIS Support Coordinator</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="ndissupportcoordinator"
                                  value={values.ndissupportcoordinator}
                                  onChange={handleChange}
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>NDIS Support Coordinator Phone</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="ndissupportcoordinatorphone"
                                  value={values.ndissupportcoordinatorphone}
                                  onChange={handleChange}
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>NDIS Item Code</Form.Label>
                                <Form.Control
                                  type="text"
                                  name="rhcndisitemcode"
                                  value={values.rhcndisitemcode}
                                  onChange={handleChange}
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="12">
                              <Form.Group>
                                <Form.Label>NDIS Billing Note</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={4}
                                  type="text"
                                  name="ndisbillingnote"
                                  value={values.ndisbillingnote}
                                  onChange={handleChange}
                                  autoComplete="new-password"
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                        </>
                      ) : null}

                      {currentProviderType !== "Financial" ? (
                        <>
                          <Row>
                            {values.paymentType !== "Contract" &&
                            values.paymentType !== "NDIS" &&
                            values.paymentType !== "EAP" &&
                            currentProviderType !== "Supervision" ? (
                              <>
                                <Col md="3">
                                  <Form.Group>
                                    <Form.Label>Medicare Card Number</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="medicareno"
                                      value={values.medicareno || ""}
                                      onChange={handleChange}
                                      autoComplete="new-password"
                                      isInvalid={touched.medicareno && !!errors.medicareno}
                                      isValid={touched.medicareno && !errors.medicareno}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.medicareno}</Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                                <Col md="3">
                                  <Form.Group>
                                    <Form.Label>Order on Card</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="medicarereferenceno"
                                      value={values.medicarereferenceno || ""}
                                      onChange={handleChange}
                                      autoComplete="new-password"
                                      isInvalid={touched.medicarereferenceno && !!errors.medicarereferenceno}
                                      isValid={touched.medicarereferenceno && !errors.medicarereferenceno}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.medicarereferenceno}</Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                                <Col md="3">
                                  <Form.Group>
                                    <Form.Label>Medicare Expiry Date</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="medicareexpirydate"
                                      value={values.medicareexpirydate || ""}
                                      onChange={handleChange}
                                      autoComplete="new-password"
                                      isInvalid={touched.medicareexpirydate && !!errors.medicareexpirydate}
                                      isValid={touched.medicareexpirydate && !errors.medicareexpirydate}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.medicareexpirydate}</Form.Control.Feedback>
                                  </Form.Group>
                                </Col>
                              </>
                            ) : null}
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>Appointment Type</Form.Label>
                                <Select
                                  variant="outlined"
                                  margin="dense"
                                  id="appointmentType"
                                  aria-label="Select Appointment Type"
                                  name="appointmentType"
                                  value={values.appointmenttype}
                                  onChange={(event) => setFieldValue("appointmenttype", event.target.value)}
                                  style={{
                                    fullWidth: true,
                                    display: "flex",
                                    wrap: "nowrap",
                                    backgroundColor: "#fff",
                                  }}
                                >
                                  <MenuItem key="Video" value="0">
                                    Video Call
                                  </MenuItem>
                                  <MenuItem key="Phone" value="1">
                                    Phone Call
                                  </MenuItem>
                                </Select>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row>
                            <Col md="3">
                              <Form.Group>
                                <Form.Label>Client Status</Form.Label>
                                <Form.Control type="text" value={values.status} readOnly style={{ backgroundColor: "#e9ecef", cursor: "default" }} />
                              </Form.Group>
                            </Col>

                            {values.specialisttype === "centralisedservice" ? (
                              <Col md="3">
                                <Form.Group>
                                  <Form.Label>Centralised Service Status</Form.Label>
                                  <Form.Control
                                    type="text"
                                    value={values.closureProviderStatus || "Active"}
                                    readOnly
                                    style={{
                                      backgroundColor: "#e9ecef",
                                      cursor: "default",
                                    }}
                                  />
                                </Form.Group>
                              </Col>
                            ) : null}
                          </Row>
                          {values.specialisttype !== "centralisedservice" && (
                            <>
                              <h5 style={{ paddingBottom: 20 }}>Registration Questions and Responses</h5>
                              <Row>
                                <Col md="6">
                                  <Form.Group>
                                    <Form.Label>
                                      Have you received a Mental Health Plan in the last 12 Months ?
                                      <span style={{ fontStyle: "italic", fontWeight: 600 }}>
                                        (Note this question is only answered if the client registered for a GP booking - originally)
                                      </span>
                                    </Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="gpmentalhealthplan12months"
                                      readOnly
                                      style={{ width: "25%", backgroundColor: "#e9ecef", cursor: "default" }}
                                      value={values.gpmentalhealthplan12months || ""}
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>
                              {values.paymentType === "Bulk Billed" || values.paymentType === "Reduced Gap" ? (
                                <>
                                  {values.paymentType === "Bulk Billed" ? (
                                    <>
                                      <Form.Label style={{ fontStyle: "italic", fontWeight: 600 }}>
                                        Note: The questions below no longer appear in the Client Registration Form but are still in the Database for older
                                        clients.{" "}
                                      </Form.Label>
                                      <Row>
                                        <Col md="3">
                                          <Form.Group>
                                            <Form.Label>Do you have a Health Care Card?</Form.Label>
                                            <Form.Control
                                              type="text"
                                              name="healthcarecard"
                                              readOnly
                                              value={values.healthcarecard || ""}
                                              style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col md="3">
                                          <Form.Group>
                                            <Form.Label>Are you Unemployed?</Form.Label>
                                            <Form.Control
                                              type="text"
                                              name="unemployed"
                                              readOnly
                                              value={values.unemployed || ""}
                                              style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col md="6">
                                          <Form.Group>
                                            <Form.Label>Have you been impacted by drought, bushfire, flood or other natural disaster?</Form.Label>
                                            <Form.Control
                                              type="text"
                                              name="naturaldisaster"
                                              readOnly
                                              value={values.naturaldisaster || ""}
                                              style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                            />
                                          </Form.Group>
                                        </Col>
                                      </Row>
                                    </>
                                  ) : null}
                                  <Row>
                                    <Col md="12">
                                      <Form.Group>
                                        <Form.Label>Please tell us why you need to be bulk billed (or reduced fee)?</Form.Label>
                                        <Form.Control
                                          as="textarea"
                                          rows={4}
                                          type="text"
                                          readOnly
                                          name="bulkbilledreason"
                                          value={values.bulkbilledreason || ""}
                                          style={{ backgroundColor: "#e9ecef", cursor: "default" }}
                                          autoComplete="new-password"
                                        />
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                </>
                              ) : null}
                            </>
                          )}
                        </>
                      ) : null}
                    </Tab>
                    {values.specialisttype === "centralisedservice" ? (
                      <Tab eventKey="CSReferral" title="CS Referral" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                        <h5>Referral Information</h5>
                        <Row>
                          <Col md="12">
                            <Form.Group>
                              <Form.Label>Purpose of referral *</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={4}
                                type="text"
                                name="referralPurpose"
                                value={values.referralPurpose}
                                readOnly
                                style={{ backgroundColor: "#e9ecef" }}
                              />
                              <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>What would the consumer like to achieve through this referral?</Form.Label>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <Form.Group>
                              <Form.Label>Presenting concerns & relevant background*</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={4}
                                type="text"
                                name="hopeToGetFromTreatment"
                                value={values.hopeToGetFromTreatment}
                                readOnly
                                style={{ backgroundColor: "#e9ecef" }}
                              />
                              <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                                Please provide details that support collaborative care, such as frequency of case conferences, support needs, etc. If referral
                                information is described in the IAR please refer to it.
                              </Form.Label>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <Form.Group>
                              <Form.Label>Current Medication</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={4}
                                type="text"
                                name="profileMedication"
                                value={values.medication}
                                readOnly
                                style={{ backgroundColor: "#e9ecef" }}
                              />
                              <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                                Please provide details of client's current medication. If current medication is described in IAR please refer to it.
                              </Form.Label>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <Form.Group>
                              <Form.Label>Identified risks and agreed management strategies*</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={4}
                                type="text"
                                name="identifiedRisksAndAgreedManagement"
                                value={values.identifiedRisksAndAgreedManagement}
                                readOnly
                                style={{ backgroundColor: "#e9ecef" }}
                              />
                              <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                                Please provide details about any identified risks and agreed management plans. You can find additional information and a
                                template in the Centralised Service Clinical Risk Assessment and Management Policy in the Resources tab.
                              </Form.Label>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="6">
                            <Form.Group style={{ width: "100%" }}>
                              <Form.Label>Centre anticipated end of care*</Form.Label>
                              <Form.Control
                                type="text"
                                name="estimatedEndOfCareDate"
                                value={values.estimatedEndOfCareDate}
                                readOnly
                                style={{ backgroundColor: "#e9ecef" }}
                              />
                            </Form.Group>
                          </Col>
                          {/* <Col md="6">
                      <Form.Group>
                        <Form.Label>Estimated total number of sessions</Form.Label>
                        <Form.Control type="text" name="csSessionExpectation" defaultValue={currentCsSessionExpect} readOnly />
                      </Form.Group>
                    </Col> */}
                        </Row>
                        <Row>
                          <Col md="12">
                            <Form.Group>
                              <Form.Label>MMHC contact and process expectations*</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={4}
                                type="text"
                                name="referralInformation"
                                value={values.referralInformation}
                                readOnly
                                style={{ backgroundColor: "#e9ecef" }}
                              />
                              <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                                Please provide details of the contact and process expectations. If current process expectations are described in the IAR, please
                                refer to it.
                              </Form.Label>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <Form.Group>
                              <Form.Label>Special Circumstances</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={4}
                                type="text"
                                name="specialCircumstances"
                                value={values.specialCircumstances}
                                readOnly
                                style={{ backgroundColor: "#e9ecef" }}
                              />
                              <Form.Label style={{ fontSize: 12, color: "#6c757d" }}>
                                Please provide details of any special circumstances. If relevant details are described in the IAR, please refer to it.
                              </Form.Label>
                            </Form.Group>
                          </Col>
                        </Row>
                        <h5>Assessments</h5>
                        <Row>
                          <Col md="6">
                            <Form.Group>
                              <Form.Label>Initial Assessment Status</Form.Label>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "2rem",
                                }}
                              >
                                <span
                                  className="text-muted"
                                  style={{
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {values.initalAssessmentOutcome || "Not Set"}
                                </span>
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="6">
                            <Form.Group>
                              <Form.Label>IAR Upload Status</Form.Label>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "2rem",
                                }}
                              >
                                <span
                                  className="text-muted"
                                  style={{
                                    fontSize: "1rem",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {values.recentIARFileURL || "No Upload"}
                                </span>
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Tab>
                    ) : null}

                    {values.providerType !== "Financial" && values.providerType !== "Supervision" ? (
                      <Tab eventKey="ClientGP" title="GP" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                        <>
                          {/* Medical Practitioner */}
                          {(values.providerType !== "Provisional" && values.providerType !== "GP") || values.specialisttype === "centralisedservice" ? (
                            <>
                              <Row>
                                <Col md="4">
                                  <h4>Client's GP</h4>
                                </Col>
                                <Col md="2" style={{ textAlign: "right" }}>
                                  <SearchIcon style={{ marginTop: 8, marginRight: -13 }} />
                                </Col>
                                <Col md="6">
                                  <Form.Group style={{ width: "100%", marginBottom: 0 }}>
                                    <Autocomplete
                                      id="profileMedicalPractitionerID"
                                      variant="outlined"
                                      options={medicalPractitioners}
                                      getOptionLabel={(option) => option.fullname}
                                      getOptionSelected={(option, value) => getMedicalPractitionerOption(option, value)}
                                      value={values.medicalPractitioner || null}
                                      onChange={(event, newValue) => {
                                        setFieldValue("medicalPractitioner", newValue);
                                        setFieldValue("medicalPractitionerID", newValue ? newValue.id : 0);
                                      }}
                                      style={{
                                        fullWidth: true,
                                        display: "flex",
                                        wrap: "nowrap",
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          type="text"
                                          variant="outlined"
                                          margin="dense"
                                          name="MedicalPractitionerSelector"
                                          style={{
                                            backgroundColor: "",
                                            margin: 0,
                                            padding: 0,
                                          }}
                                          inputProps={{
                                            ...params.inputProps,
                                            autoComplete: "new-password",
                                          }}
                                        />
                                      )}
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>
                              <hr></hr>
                              <Row>
                                <Col md="3">
                                  <Form.Group controlId="currentMedicalPractitionerFirstName">
                                    <Form.Label>Firstname</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="firstName"
                                      value={values.medicalPractitioner ? values.medicalPractitioner.firstName : ""}
                                      onChange={(event) =>
                                        setFieldValue("medicalPractitioner", {
                                          ...values.medicalPractitioner,
                                          firstName: event.target.value,
                                        })
                                      }
                                      autoComplete="new-password"
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md="3">
                                  <Form.Group controlId="currentMedicalPractitionerSurname">
                                    <Form.Label>Surname</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="surname"
                                      value={values.medicalPractitioner ? values.medicalPractitioner.surname : ""}
                                      onChange={(event) =>
                                        setFieldValue("medicalPractitioner", {
                                          ...values.medicalPractitioner,
                                          surname: event.target.value,
                                        })
                                      }
                                      autoComplete="new-password"
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md="3">
                                  <Form.Group controlId="currentMedicalPractitionerMobilePhone">
                                    <Form.Label>Mobile Phone</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="mobilephone"
                                      value={values.medicalPractitioner ? values.medicalPractitioner.mobilephone : ""}
                                      onChange={(event) =>
                                        setFieldValue("medicalPractitioner", {
                                          ...values.medicalPractitioner,
                                          mobilephone: event.target.value,
                                        })
                                      }
                                      autoComplete="new-password"
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md="3">
                                  <Form.Group controlId="currentMedicalPractitionerProviderNo">
                                    <Form.Label>Provider Number</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="providernumber"
                                      value={values.medicalPractitioner ? values.medicalPractitioner.providernumber : ""}
                                      onChange={(event) =>
                                        setFieldValue("medicalPractitioner", {
                                          ...values.medicalPractitioner,
                                          providernumber: event.target.value,
                                        })
                                      }
                                      autoComplete="new-password"
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>
                              {/* Medical Practice */}
                              <Row>
                                <Col md="4">
                                  <h4>Practice</h4>
                                </Col>
                                <Col md="2" style={{ textAlign: "right" }}>
                                  <SearchIcon style={{ marginTop: 8, marginRight: -13 }} />
                                </Col>
                                <Col md="6">
                                  <Form.Group style={{ width: "100%", marginBottom: 0 }}>
                                    <Autocomplete
                                      id="profileMedicalPractice"
                                      variant="outlined"
                                      options={medicalPractices}
                                      getOptionLabel={(option) => option.practicename}
                                      getOptionSelected={(option, value) => getMedicalPracticeOption(option, value)}
                                      value={values.medicalPractice || null}
                                      onChange={(event, newValue) => setFieldValue("medicalPractice", newValue)}
                                      style={{
                                        fullWidth: true,
                                        display: "flex",
                                        wrap: "nowrap",
                                      }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          type="text"
                                          variant="outlined"
                                          margin="dense"
                                          name="MedicalPracticeSelector"
                                          style={{
                                            backgroundColor: "",
                                            margin: 0,
                                            padding: 0,
                                          }}
                                          inputProps={{
                                            ...params.inputProps,
                                            autoComplete: "new-password",
                                          }}
                                        />
                                      )}
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>
                              <hr></hr>
                              <Row>
                                <Col md="5">
                                  <Form.Group>
                                    <Form.Label>Clinic Name</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="practicename"
                                      value={values.medicalPractice ? values.medicalPractice.practicename : ""}
                                      onChange={(event) =>
                                        setFieldValue("medicalPractice", {
                                          ...values.medicalPractice,
                                          practicename: event.target.value,
                                        })
                                      }
                                      autoComplete="new-password"
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md="3">
                                  <Form.Group>
                                    <Form.Label>ABN</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="currentAbn"
                                      value={values.medicalPractice ? values.medicalPractice.abn : ""}
                                      onChange={(event) =>
                                        setFieldValue("medicalPractice", {
                                          ...values.medicalPractice,
                                          abn: event.target.value,
                                        })
                                      }
                                      autoComplete="new-password"
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md="3">
                                  <Form.Group>
                                    <Form.Label>Contact Phone</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="currentPhone"
                                      value={values.medicalPractice ? values.medicalPractice.phone : ""}
                                      onChange={(event) =>
                                        setFieldValue("medicalPractice", {
                                          ...values.medicalPractice,
                                          phone: event.target.value,
                                        })
                                      }
                                      autoComplete="new-password"
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md="6">
                                  <Form.Group>
                                    <Form.Label>Clinic Address</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="currentAddress1"
                                      value={values.medicalPractice ? values.medicalPractice.address1 : ""}
                                      onChange={(event) =>
                                        setFieldValue("medicalPractice", {
                                          ...values.medicalPractice,
                                          address1: event.target.value,
                                        })
                                      }
                                      autoComplete="new-password"
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md="3">
                                  <Form.Group>
                                    <Form.Label>Clinic Fax</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="currentFax"
                                      value={values.medicalPractice ? values.medicalPractice.fax : ""}
                                      onChange={(event) =>
                                        setFieldValue("medicalPractice", {
                                          ...values.medicalPractice,
                                          fax: event.target.value,
                                        })
                                      }
                                      autoComplete="new-password"
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md="3">
                                  <Form.Group>
                                    <Form.Label>Clinic Email</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="currentEmail"
                                      value={values.medicalPractice ? values.medicalPractice.email : ""}
                                      onChange={(event) =>
                                        setFieldValue("medicalPractice", {
                                          ...values.medicalPractice,
                                          email: event.target.value,
                                        })
                                      }
                                      autoComplete="new-password"
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>
                            </>
                          ) : (
                            <>
                              <Row>
                                <Col md="4">
                                  <h4>Client's GP</h4>
                                </Col>
                              </Row>
                              <Row>
                                <Col md="3">
                                  <Form.Group>
                                    <Form.Label>GP Name</Form.Label>
                                    <Form.Control type="text" name="gpName" value={values.gpName} onChange={handleChange} autoComplete="new-password" />
                                  </Form.Group>
                                </Col>
                                <Col md="3">
                                  <Form.Group>
                                    <Form.Label>GP Clinic Name</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="gpClinicName"
                                      value={values.gpClinicName}
                                      onChange={handleChange}
                                      autoComplete="new-password"
                                    />
                                  </Form.Group>
                                </Col>
                                <Col md="3">
                                  <Form.Group>
                                    <Form.Label>GP Contact Number</Form.Label>
                                    <Form.Control
                                      type="text"
                                      name="gpContactNumber"
                                      value={values.gpContactNumber}
                                      onChange={handleChange}
                                      autoComplete="new-password"
                                    />
                                  </Form.Group>
                                </Col>
                                {currentProviderType === "GP" ? (
                                  <Col md="6">
                                    <Form.Group>
                                      <Form.Label>Client consent to share their Mental Health Treatment Plan with their GP</Form.Label>
                                      <Form.Control as="select" name="consentToShareWithGP" value={values.consentToShareWithGP} onChange={handleChange}>
                                        <option value=""></option>
                                        <option value="N">No</option>
                                        <option value="Y">Yes</option>
                                      </Form.Control>
                                    </Form.Group>
                                  </Col>
                                ) : null}
                              </Row>
                            </>
                          )}
                        </>
                      </Tab>
                    ) : null}
                    <Tab
                      eventKey="Notes"
                      title="Notes"
                      style={{
                        backgroundColor: "rgb(245, 245, 245)",
                        padding: 6,
                      }}
                    >
                      <Notes
                        type="Client"
                        pkid={values.id}
                        firstName={values.preferredname && values.preferredname.length > 2 ? values.preferredname : values.firstname}
                        medicalPractice={currentMedicalPractice}
                        waitingRoomURL={registered && (registered.teleHealthProvider === "COVIU" ? registered.coviuRoomURL : registered.waitingRoomURL)}
                        faxGP={values.referralGPPracticeFax}
                        ownerName={values.ownerFirstName}
                        specialistType={values.specialisttype}
                        email={values.email}
                        mobilephone={values.mobilephone}
                        providerTotal={values.providerTotal}
                        viewType="NoteOnly"
                      />
                    </Tab>
                    <Tab eventKey="ClientScores" title="Scores" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                      <ClientScores clientID={values.id} />
                    </Tab>
                    <Tab eventKey="Communications" title="Communications" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                      <Notes
                        type="Client"
                        pkid={values.id}
                        firstName={values.preferredname && values.preferredname.length > 2 ? values.preferredname : values.firstname}
                        waitingRoomURL={registered && (registered.teleHealthProvider === "COVIU" ? registered.coviuRoomURL : registered.waitingRoomURL)}
                        faxGP={values.referralGPPracticeFax}
                        ownerName={values.ownerFirstName}
                        specialistType={values.specialisttype}
                        email={values.email}
                        mobilephone={values.mobilephone}
                        providerTotal={values.providerTotal}
                        viewType="CommunicationOnly"
                      />
                    </Tab>
                    <Tab eventKey="Files" title="Files" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                      <Files type="Client" subtype={values.paymentType} pkid={values.id} specialistType={values.specialisttype} />
                    </Tab>
                    {currentProviderType !== "Financial" && currentProviderType !== "GP" ? (
                      <Tab eventKey="referrals" title="Referrals" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                        <ReferralMaintenance
                          viewerFullName={`${values.firstName} ${values.surname}`}
                          clientID={values.id}
                          psychologistID={registered && registered.id}
                          type={"client"}
                        />
                      </Tab>
                    ) : null}
                    <Tab eventKey="bookings" title="Bookings" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                      <BookingsList
                        type="client"
                        id={values.id}
                        userTZ={currentTimeZone}
                        view="psychologist"
                        providerType={currentProviderType}
                        specialistType={values.specialisttype}
                      />
                    </Tab>
                    <Tab eventKey="Billing" title="Billing" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                      <BookingBillingList
                        id={values.id}
                        clientFirstName={values.firstName}
                        clientPreferredName={values.preferredname}
                        clientSurname={values.surname}
                        clientDOB={values.dob}
                        clientEmail={values.email}
                        clientMobile={values.mobilephone}
                        clientMedicareNo={values.medicareno}
                        clientMedicareReferenceNo={values.medicarereferenceno}
                        clientMedicareExpiryDate={values.medicareexpirydate}
                        clientreferringGPName={values.referringGPName}
                        clientreferringGPProviderNo={values.referringGPProviderNo}
                        clientreferredOn={values.referredGPOn}
                      />
                    </Tab>
                    <Tab eventKey="Audit" title="Audit" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                      <AuditLog clientID={values.id} />
                    </Tab>
                  </Tabs>
                  {Object.keys(errors).length > 0 && (
                    <div
                      style={{
                        backgroundColor: "#f8d7da",
                        border: "1px solid #f5c2c7",
                        borderRadius: "6px",
                        padding: "12px 16px",
                        margin: "12px 0",
                        color: "#842029",
                      }}
                    >
                      <strong>Please fix the following errors:</strong>
                      <ul style={{ marginBottom: 0, marginTop: "8px" }}>
                        {Object.entries(errors).map(([field, message]) => (
                          <li key={field}>
                            <strong>{fieldLabels[field] || field}:</strong> {message}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </Modal.Body>
                <Modal.Footer className="editprofile-modal">
                  <Button variant="secondary" onClick={() => setShow(false)}>
                    Cancel
                  </Button>
                  <Button variant="primary" type="button" onClick={handleSubmit}>
                    Save
                  </Button>
                </Modal.Footer>
              </form>
            );
          }}
        </Formik>
      </Modal>

      <Modal show={showAppointment} onHide={() => setShowAppointment(false)} dialogClassName="editappointment-modal">
        <Modal.Header closeButton className="editappointment-modal">
          <Modal.Title>
            Appointments - {currentFirstName} {currentSurname}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="editappointment-modal">
          {registered ? (
            <BookingWeek
              mode="psychologist"
              psychologistID={registered && registered.id}
              psychologistFullname={registered.firstname + " " + registered.surname}
              clientID={currentClientID && currentClientID}
              clientFullname={
                currentFirstName &&
                (currentPreferredName && currentPreferredName.length > 2
                  ? currentPreferredName + " " + currentSurname
                  : currentFirstName + " " + currentSurname)
              }
              clientFirstName={currentFirstName}
              clientPreferredName={currentPreferredName}
              currentHourlyRate={registered.hourlyrate}
              currentWaitingRoomURL={registered && (registered.teleHealthProvider === "COVIU" ? registered.coviuRoomURL : registered.waitingRoomURL)}
              clientEmail={currentEmail}
              psychologistTZ={registered.timeZone}
              clientTZ={currentTimeZone}
              providerType={currentPaymentType}
              bookingType={currentClientBookingType}
              setShowAppointment={setShowAppointment}
            />
          ) : null}
        </Modal.Body>
        <Modal.Footer className="editappointment-modal">
          <Button variant="secondary" onClick={() => setShowAppointment(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showBooking} onHide={() => setShowBooking(false)} dialogClassName="new-bookingDialog-modal" centered>
        <Modal.Header closeButton className="new-booking-modal">
          <Modal.Title>Booking - {booking.status}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="new-booking-modal" style={{ backgroundColor: "rgb(245,245,245)" }}>
          {!toggleMessage ? (
            <Grid container spacing={3} style={{ height: 247 }}>
              <Grid item md={3} xs={6}>
                Provider:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {booking.psychologistfullname}
              </Grid>
              <Grid item md={3} xs={6}>
                Client:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {booking.clientfullname}
              </Grid>
              <Grid item md={3} xs={6}>
                Date:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {format(new Date(booking.psychologistDate ? booking.psychologistDate : null), "dd-MM-yyyy")}
              </Grid>
              <Grid item md={3} xs={6}>
                Time:
              </Grid>
              <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                {format(new Date(booking.psychologistDate ? booking.psychologistDate : null), "h:mm aa")}
              </Grid>
              {booking.clientDate !== booking.psychologistDate ? (
                <>
                  <Grid item md={3} xs={6}>
                    Client's Time:
                  </Grid>
                  <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
                    {format(new Date(booking.clientDate ? booking.clientDate : null), "h:mm aa")}
                  </Grid>
                </>
              ) : null}
              {/* <Grid item md={3} xs={6}>
              Session URL:
            </Grid>
            <Grid item md={9} xs={6} style={{ fontWeight: 600 }}>
              <a href={booking.waitingroomurl} target="_blank" rel="noopener noreferrer">
                {booking.waitingroomurl}
              </a>
            </Grid> */}
            </Grid>
          ) : sentMsg ? (
            <>
              <Row>
                <Col md="12" style={{ height: 222 }}>
                  {sentMsg}
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row>
                <Col md="12">
                  <Form.Group>
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={8}
                      type="text"
                      name="psychologistNote"
                      defaultValue={newNote}
                      onBlur={(event) => setNewNote(event.target.value)}
                      autoComplete="new-password"
                      style={{ borderColor: "#D1D1D1" }}
                    />
                    {/* {newNoteHelpText.length ? (<p className='error-help'>{newNoteHelpText}</p>) : ''} */}
                  </Form.Group>
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="new-booking-modal">
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            {!toggleMessage ? (
              <>
                <Grid item>{getActionButtons(booking.id)}</Grid>
                <Grid item>
                  <Button variant="primary" size="sm" onClick={() => setToggleMessage(!toggleMessage)} style={{ marginRight: 15 }}>
                    Message
                  </Button>
                  <Button variant="secondary" size="sm" onClick={() => setShowBooking(false)} className="lightButtonOutlinedLarge">
                    Close
                  </Button>
                </Grid>
              </>
            ) : (
              <>
                <Grid item>
                  <Button variant="secondary" size="sm" onClick={() => setToggleMessage(!toggleMessage)} className="lightButtonOutlinedLarge">
                    Cancel
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="success" size="sm" onClick={() => sendMessage()}>
                    Send &gt;
                  </Button>
                </Grid>
              </>
            )}
          </Grid>
        </Modal.Footer>
      </Modal>

      <Modal show={showNotes} onHide={() => setShowNotes(false)} dialogClassName="notes-modal-dialog">
        <Modal.Header closeButton className="notes-modal">
          <Modal.Title>
            {currentNoteViewType === "CommunicationOnly" ? "Communications" : "Notes"} - {currentFirstName} {currentSurname}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="notes-modal">
          {registered ? (
            <Notes
              type="Client"
              ownerName={currentOwnerFirstName}
              specialistType={currentSpecialistType}
              noteAction={noteAction}
              pkid={currentClientID}
              firstName={currentPreferredName && currentPreferredName.length > 2 ? currentPreferredName : currentFirstName}
              faxGP={currentReferralGPPracticeFax}
              medicalPractice={currentMedicalPractice}
              waitingRoomURL={registered && (registered.teleHealthProvider === "COVIU" ? registered.coviuRoomURL : registered.waitingRoomURL)}
              psychologistFullName={registered.firstname + " " + registered.surname}
              clientFirstName={currentFirstName}
              email={currentEmail}
              mobilephone={currentMobile}
              viewType={currentNoteViewType}
            />
          ) : null}
        </Modal.Body>
        <Modal.Footer className="notes-modal">
          <Button variant="secondary" onClick={() => setShowNotes(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showFiles} onHide={() => setShowFiles(false)} dialogClassName="notes-modal-dialog">
        <Modal.Header closeButton className="notes-modal">
          <Modal.Title>
            Files - {currentFirstName} {currentSurname}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="notes-modal">
          {registered ? <Files type="Client" subtype={currentPaymentType} pkid={currentClientID} specialistType={currentSpecialistType} /> : null}
        </Modal.Body>
        <Modal.Footer className="notes-modal">
          <Button variant="secondary" onClick={() => setShowFiles(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showConfirmation} onHide={() => setShowConfirmation(false)} dialogClassName="notes-modal-dialog">
        <Modal.Header closeButton className="notes-modal">
          <Modal.Title>
            {currentAction === "Active" ? "Re activate - " : "Archive - "} {currentFirstName} {currentSurname} ?
          </Modal.Title>
        </Modal.Header>
        <Modal.Footer className="notes-modal">
          <Button variant="secondary" onClick={() => setShowConfirmation(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={putArchive}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showCSComplete} onHide={() => setShowCSComplete(false)} dialogClassName="csComplete-modal">
        <Modal.Header closeButton className="csComplete-modal">
          <Modal.Title>
            Mark {currentFirstName} {currentSurname} as Complete
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="csComplete-modal-body">
          <p>You are marking this referral as complete. </p>
          <p>This will notify the referring Medicare Mental Health Centre contact. </p>
          <p>
            <span style={{ fontWeight: "bold" }}>Please make sure you have loaded all relevant reports into the “Files” tab.</span>
          </p>
        </Modal.Body>
        <Modal.Footer className="csComplete-modal">
          <Button variant="secondary" onClick={() => setShowCSComplete(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={putCSComplete}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showToDo} onHide={() => setShowToDo(false)} dialogClassName="todos-modal-dialog">
        <Modal.Header closeButton className="todos-modal">
          <Modal.Title>To Do - {toDoTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="todos-modal">{toDoClientID && <ToDos clientID={toDoClientID} setShowToDo={setShowToDo} />}</Modal.Body>
      </Modal>

      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
